/** Lets login flow sync user settings without circular imports. */
const syncUserSettingsFns = new Set();

export const registerUserSettingsSync = (syncFn) => {
  if (syncFn === null) {
    syncUserSettingsFns.clear();
    return () => {};
  }
  if (typeof syncFn !== "function") return () => {};

  syncUserSettingsFns.add(syncFn);
  return () => {
    syncUserSettingsFns.delete(syncFn);
  };
};

export const triggerUserSettingsSync = async () => {
  if (!syncUserSettingsFns.size) return [];

  const results = await Promise.all(
    [...syncUserSettingsFns].map((syncFn) => syncFn())
  );
  return results.flat();
};
